export default __webpack_public_path__ + "static/media/lemontbotanique_background_xl2.2df369f3.jpg";